export default (event, payload) => {
  if (window._satellite) {
    window._satellite.track(event, payload);
  }
};
